/* istanbul ignore file */
import * as React from "react";
import type { SVGProps } from "react";
import PropTypes from "prop-types";

interface Props extends SVGProps<SVGSVGElement> {
  srText?: string;
  size?: "sm" | "md" | "lg" | "scale-8" | "scale-10" | number;
  alt?: string;
}
function IconPencilAndRuler({
  srText,
  size = "md",
  className = "",
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return (
    <>
      {!!srText && <span className="mc-sr-only">{srText}</span>}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        aria-hidden="true"
        role="img"
        className={newClassName}
        {...props}
      >
        <defs>
          <clipPath id="pencil-and-ruler_svg__a">
            <path d="M2 1h8v22.293H2Zm0 0" />
          </clipPath>
          <clipPath id="pencil-and-ruler_svg__b">
            <path d="M12 .707h11v22.586H12Zm0 0" />
          </clipPath>
        </defs>
        <g clipPath="url(#pencil-and-ruler_svg__a)">
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.50070088}
            d="M6.336 22.586a2.823 2.823 0 0 1-2.824-2.82V7.726c0-.44.101-.87.297-1.265l1.894-3.785a.7.7 0 0 1 .262-.285.703.703 0 0 1 1 .285L8.859 6.46c.2.394.301.824.301 1.266v12.039c0 .746-.3 1.464-.828 1.996a2.84 2.84 0 0 1-1.996.824m0 0"
          />
        </g>
        <path
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.50070088}
          d="M3.59 7.059h5.488M3.512 19.059H9.16"
        />
        <g clipPath="url(#pencil-and-ruler_svg__b)">
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.50070088}
            d="M20.453 1.41h-5.648c-.778 0-1.41.633-1.41 1.414v18.352c0 .781.632 1.414 1.41 1.414h5.648c.777 0 1.41-.633 1.41-1.414V2.824c0-.781-.633-1.414-1.41-1.414m0 0"
          />
        </g>
        <path
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.50070088}
          d="M13.395 5.648h2.824M13.395 9.883h2.824M13.395 14.117h2.824M13.395 18.352h2.824"
        />
      </svg>
    </>
  );
}
IconPencilAndRuler.propTypes = {
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
} as PropTypes.ValidationMap<Props>;
export default IconPencilAndRuler;
